"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getTimeline = void 0;
const moment_1 = __importDefault(require("moment"));
const jobStatusCodes_1 = require("../constants/jobStatusCodes");
const dateFormatters_1 = require("./dateFormatters");
const getStatusViewData = ({ statusOld, statusNew, firstName, lastName }) => {
    let statusText = '';
    let icon = 'directionsCar';
    const fullName = `${firstName} ${lastName}`;
    let hasName = true;
    switch (statusNew) {
        case jobStatusCodes_1.JobStatus.ProviderEnroute:
            icon = 'directionsCar';
            statusText = 'is_en_route';
            break;
        case jobStatusCodes_1.JobStatus.ProviderOnsite:
            icon = 'house';
            statusText = 'is_on_site';
            break;
        case jobStatusCodes_1.JobStatus.ProviderTimerRequested:
            icon = 'playArrow';
            statusText = 'requested_to_start_job';
            break;
        case jobStatusCodes_1.JobStatus.ConsumerTimerRejected:
            icon = 'house';
            statusText = 'rejected_the_request';
            break;
        case jobStatusCodes_1.JobStatus.ConsumerTimerAccepted:
            icon = 'playArrow';
            statusText = 'the_job_started';
            hasName = false;
            break;
        case jobStatusCodes_1.JobStatus.ProviderPaused:
            icon = 'pause';
            statusText = 'the_job_paused';
            hasName = false;
            break;
        case jobStatusCodes_1.JobStatus.ProviderResumeRequested:
            icon = 'playArrow';
            statusText = 'requested_to_resume';
            break;
        case jobStatusCodes_1.JobStatus.ConsumerResumeRejected:
            icon = 'pause';
            statusText = 'rejected_the_request';
            break;
        case jobStatusCodes_1.JobStatus.ConsumerResumeAccepted:
            icon = 'playArrow';
            statusText = 'the_job_resumed';
            hasName = false;
            break;
        case jobStatusCodes_1.JobStatus.ProviderSuspendRequested:
            icon = 'stop';
            statusText = 'request_to_suspend';
            break;
        case jobStatusCodes_1.JobStatus.ConsumerSuspendRejected:
            icon = 'pause';
            statusText = 'rejected_the_request';
            break;
        case jobStatusCodes_1.JobStatus.ConsumerSuspendAccepted:
            icon = 'stop';
            statusText = 'the_job_suspended';
            hasName = false;
            break;
        case jobStatusCodes_1.JobStatus.ProviderUnsuspendRequested:
            icon = 'stop';
            statusText = 'requested_to_restart_job';
            break;
        case jobStatusCodes_1.JobStatus.ConsumerUnsuspendRejected:
            icon = 'pause';
            statusText = 'rejected_the_request';
            break;
        case jobStatusCodes_1.JobStatus.ConsumerUnsuspendAccepted:
            icon = 'stop';
            statusText = 'the_job_restarted';
            hasName = false;
            break;
        case jobStatusCodes_1.JobStatus.ProviderUnsuspendCancelled:
            icon = 'stop';
            if (statusOld === jobStatusCodes_1.JobStatus.ConsumerScheduleRequested) {
                statusText = 'rejected_the_request';
            }
            else {
                statusText = 'resuspended_the_job';
            }
            break;
        case jobStatusCodes_1.JobStatus.ConsumerScheduleRequested:
            icon = 'stop';
            statusText = 'created_schedule_request';
            break;
        case jobStatusCodes_1.JobStatus.ProviderScheduleAccepted:
            icon = 'stop';
            statusText = 'accepted_the_request';
            break;
        case jobStatusCodes_1.JobStatus.ProviderCompleted:
            icon = 'check';
            statusText = 'the_job_completed';
            hasName = false;
            break;
        case jobStatusCodes_1.JobStatus.ProviderFinalizeRequested:
            icon = 'check';
            statusText = 'requested_to_finalize';
            break;
        case jobStatusCodes_1.JobStatus.ConsumerFinalizeRejected:
            icon = 'check';
            statusText = 'rejected_the_request';
            break;
        case jobStatusCodes_1.JobStatus.ConsumerFinalizeAccepted:
            icon = 'check';
            statusText = 'the_job_finalized';
            hasName = false;
            break;
        case jobStatusCodes_1.JobStatus.ConsumerEndRequested:
            icon = 'stop';
            statusText = 'request_to_terminate';
            break;
        case jobStatusCodes_1.JobStatus.ProviderEndRejected:
            icon = 'stop';
            statusText = 'rejected_the_request';
            break;
        case jobStatusCodes_1.JobStatus.ProviderEndAccepted:
            icon = 'stop';
            statusText = 'the_job_terminated';
            hasName = false;
            break;
        default:
            return;
    }
    return { statusText, icon, fullName, hasName };
};
const getDateTimeData = (date) => {
    const dateMoment = moment_1.default.utc(date);
    return {
        date,
        timeStr: dateFormatters_1.formatHourMinute(dateMoment.local()),
        dateStr: dateFormatters_1.formatDate(dateMoment.local()),
        datetimeStr: dateFormatters_1.formatDateTime(dateMoment.local()),
    };
};
const addDatetimeStr = list => {
    const dateList = [];
    for (let i = list.length - 1; i >= 0; i--) {
        const item = list[i];
        if (item.date) {
            const { timeStr, dateStr, datetimeStr } = getDateTimeData(item.date);
            let result = timeStr;
            if (!dateList.includes(dateStr)) {
                result = datetimeStr;
                dateList.push(dateStr);
            }
            item.datetimeStr = result;
        }
    }
};
const latestSort = (a, b) => {
    const momentA = moment_1.default(a.date);
    const momentB = moment_1.default(b.date);
    if (momentA > momentB) {
        return -1;
    }
    else if (momentA < momentB) {
        return 1;
    }
    else {
        return 0;
    }
};
const getTimeline = ({ status, consumerRequestNote, requestCreatedAt, consumerName, jobNotes, providerName, requestImages, timelineImages, translations, }) => {
    const newTimeline = [];
    status === null || status === void 0 ? void 0 : status.forEach(({ createdAt, statusNew, statusOld, user: { firstName, lastName } }) => {
        if (statusOld === jobStatusCodes_1.JobStatus.ConsumerResumeAccepted &&
            statusNew === jobStatusCodes_1.JobStatus.ConsumerTimerAccepted) {
            return;
        }
        const viewData = getStatusViewData({
            statusNew,
            statusOld,
            firstName,
            lastName,
        });
        newTimeline.push(Object.assign(Object.assign({}, viewData), { date: createdAt, type: 'status', key: `timeline-${Math.random()}` }));
    });
    if (consumerRequestNote) {
        const tempNote = {
            key: `note-${Math.random()}`,
            type: 'note',
            note: consumerRequestNote,
            date: requestCreatedAt,
            name: consumerName,
            icon: 'noteAdd',
        };
        newTimeline.push(Object.assign({}, tempNote));
    }
    if (jobNotes && jobNotes.note) {
        const tempNote = {
            key: `note-${Math.random()}`,
            type: 'note',
            note: jobNotes.note,
            date: jobNotes.updatedAt,
            name: providerName,
            icon: 'noteAdd',
        };
        newTimeline.push(Object.assign({}, tempNote));
    }
    if (requestImages && requestImages.length > 0) {
        let tempDate = null;
        let tempImages = [];
        requestImages.forEach((item, index) => {
            const dateData = getDateTimeData(item.createdAt);
            if (!tempDate) {
                tempDate = dateData;
                tempImages = [item];
            }
            else if (dateData.timeStr !== tempDate.timeStr) {
                const image = {
                    key: `image-${Math.random()}`,
                    type: 'image',
                    images: tempImages,
                    name: consumerName,
                    date: tempDate.date,
                    icon: 'camera',
                };
                newTimeline.push(image);
                tempDate = dateData;
                tempImages = [item];
            }
            else {
                tempImages.push(item);
            }
            if (index === requestImages.length - 1) {
                const image = {
                    key: `image-${Math.random()}`,
                    type: 'image',
                    images: tempImages,
                    name: consumerName,
                    date: tempDate.date,
                    icon: 'camera',
                };
                newTimeline.push(image);
            }
        });
    }
    if (timelineImages && timelineImages.length > 0) {
        let tempDate = null;
        let tempImages = [];
        timelineImages.forEach((item, index) => {
            const dateData = getDateTimeData(item.createdAt);
            if (!tempDate) {
                tempDate = dateData;
                tempImages = [item];
            }
            else if (dateData.timeStr !== tempDate.timeStr) {
                const image = {
                    key: `image-${Math.random()}`,
                    type: 'image',
                    images: tempImages,
                    name: providerName,
                    date: tempDate.date,
                    icon: 'camera',
                };
                newTimeline.push(image);
                tempDate = dateData;
                tempImages = [item];
            }
            else {
                tempImages.push(item);
            }
            if (index === timelineImages.length - 1) {
                const image = {
                    key: `image-${Math.random()}`,
                    type: 'image',
                    images: tempImages,
                    name: providerName,
                    date: tempDate.date,
                    icon: 'camera',
                };
                newTimeline.push(image);
            }
        });
    }
    if ((consumerName === null || consumerName === void 0 ? void 0 : consumerName.length) > 0) {
        newTimeline.push({
            icon: 'checkCircle',
            statusText: `${consumerName} ${translations.requested} ${translations.theJob}`,
            date: requestCreatedAt,
            type: 'status',
            key: `timeline-${Math.random()}`,
        });
    }
    newTimeline.sort(latestSort);
    addDatetimeStr(newTimeline);
    return newTimeline;
};
exports.getTimeline = getTimeline;
